var _path, _circle, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.52311 23.4133C3.70653 24.2527 4.42704 24.8904 5.28621 24.8904H28.6807C29.5399 24.8904 30.259 24.2523 30.4486 23.4143C30.8224 21.7626 31.2692 20.6723 31.2692 16.0485C31.2692 11.4247 30.8224 10.3344 30.4486 8.68273C30.259 7.84474 29.5399 7.2066 28.6807 7.2066L5.28621 7.2066C4.42704 7.2066 3.70653 7.84429 3.52311 8.68365C3.14843 10.3983 2.69775 11.585 2.69775 16.0485C2.69775 20.512 3.14843 21.6987 3.52311 23.4133Z",
    fill: "#84C70D",
    fillOpacity: 0.3,
    stroke: "#84C70D",
    strokeWidth: 2.57499
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9833,
    cy: 16.0487,
    r: 3.42857,
    fill: "#0A0C13",
    stroke: "#84C70D",
    strokeWidth: 2.57499
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80713 12.0266L9.19818 12.0087",
    stroke: "#84C70D",
    strokeWidth: 2.57499,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0215 20.0266L26.4125 20.0087",
    stroke: "#84C70D",
    strokeWidth: 2.57499,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCard);
export default __webpack_public_path__ + "static/media/payment-card.7bcfc60174101fe518fe46e41832a6f2.svg";
export { ForwardRef as ReactComponent };